import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

document.addEventListener('DOMContentLoaded', function(){
	const carousels = document.querySelectorAll('.wv-product-carousel.splide');
	carousels.forEach((el) => {
		new Splide(el, {
			type: 'loop',
			perPage: 4,
			perMove: 1,
			gap: '1rem',
			arrows: true,
			pagination: false,
			breakpoints: {
				1024: { perPage: 3 },
				768: { perPage: 2 },
				480: { perPage: 1 },
			}
		}).mount();
	});
}); 